import cart from './slices/cart';
import auth from './slices/auth';
import search from './slices/search';
import caseData from './slices/caseData';
import programData from './slices/programData';

const rootReducer = {
  auth,
  cart,
  search,
  caseData,
  programData,
};

export default rootReducer;
